import React, {Ref, useCallback, useEffect} from 'react';
import Supercluster, {ClusterProperties} from 'supercluster';
import {FeaturesClusterMarker} from './FeaturesClusterMarker';
import FeatureMarker from './FeatureMarker';
import {useSupercluster} from '../hooks/use-supercluster.ts';
//import {Feature, FeatureCollection, GeoJsonProperties, Point} from 'geojson';


const superclusterOptions = {
  extent: 256,
  radius: 80,
  maxZoom: 22
};

export const ClusteredMarkers = ({
  geojson,
  setNumClusters,
  setInfowindowData
}) => {
  const {clusters, getLeaves} = useSupercluster(geojson, superclusterOptions);

  console.log(clusters);
  useEffect(() => {
    setNumClusters(clusters.length);
  }, [setNumClusters, clusters.length]);

  useEffect(() => {
    console.log(clusters);
  }, [clusters]);

  const handleClusterClick = useCallback(
    (marker, clusterId) => {
      const leaves = getLeaves(clusterId);
      console.log(leaves);
      setInfowindowData({anchor: marker, features: leaves});
    },
    [getLeaves, setInfowindowData]
  );

  const handleMarkerClick = useCallback(
    (marker, featureId) => {
      const feature = clusters.find(
        feat => feat.id === featureId
      );
      console.log(feature);

      setInfowindowData({anchor: marker, features: [feature]});
    },
    [clusters, setInfowindowData]
  );

  const getClusterStatus = (clusterid) => {
    const leaves = getLeaves(clusterid);
    let status = "unknown";
    leaves.forEach((leave)=>{
        if(status === "unknown" && leave.properties.status === 'ok')
            status = 'ok';
        else if(status === "unknown" && leave.properties.status === 'ko')
            status = 'ko';
        else if(status === "ok" && leave.properties.status === 'ko')
            status = 'kok';
        else if(status === "ko" && leave.properties.status === 'ok')
            status = 'kok';
    })
    return status;
  }

  return (
    <>
      {clusters.map(feature => {
        const [lng, lat] = feature.geometry.coordinates;

        const clusterProperties = feature.properties;
        const isCluster = clusterProperties.cluster;

        return isCluster ? (
          <FeaturesClusterMarker
            key={feature.id}
            clusterId={clusterProperties.cluster_id}
            position={{lat, lng}}
            status={getClusterStatus(clusterProperties.cluster_id)}
            size={clusterProperties.point_count}
            sizeAsText={String(clusterProperties.point_count_abbreviated)}
            onMarkerClick={handleClusterClick}
          />
        ) : (
          <FeatureMarker
            key={feature.id}
            properties={feature.properties}
            featureId={feature.id}
            position={{lat, lng}}
            onMarkerClick={handleMarkerClick}
          />
        );
      })}
    </>
  );
};
